"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowConfigInvokeActionDialog = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const Workflow_context_1 = require("../Workflow.context");
const StyledDiv = styled_components_1.default.div `
  margin-top: 12px;
`;
const WorkflowConfigInvokeActionDialog = props => {
    const { open, stateNode, taskTypeId, onCancel, onChange } = props;
    const { servicePlugins } = (0, Workflow_context_1.useWorkflowContext)();
    const [action, setAction] = (0, react_1.useState)(props.invoke);
    const plugin = (action === null || action === void 0 ? void 0 : action.src)
        ? servicePlugins.find(plugin => plugin.src === action.src)
        : undefined;
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, "Configure an Action"),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.DialogContentText, { gutterBottom: true }, "Perform an action when transitioning to this state."),
            react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Action Type', value: (action === null || action === void 0 ? void 0 : action.src) || '', onChange: event => {
                    const src = event.target.value;
                    setAction({ src });
                } },
                react_1.default.createElement(core_1.MenuItem, { selected: true, disabled: true }, "Select an action"),
                servicePlugins.map(plugin => (react_1.default.createElement(core_1.MenuItem, { key: plugin.src, value: plugin.src }, plugin.name)))),
            action && plugin ? (react_1.default.createElement(StyledDiv, null,
                react_1.default.createElement(plugin.configurator, { invoke: action, stateNode: stateNode, taskTypeId: taskTypeId, onChange: action => setAction(Object.assign({}, action)) }))) : ((action === null || action === void 0 ? void 0 : action.src) && (react_1.default.createElement(lab_1.Alert, { severity: 'error' },
                "Invoke Action \"",
                action.src,
                "\" plugin not found.")))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { color: 'primary', onClick: () => onCancel === null || onCancel === void 0 ? void 0 : onCancel() }, "Cancel"),
            react_1.default.createElement(core_1.Button, { variant: 'contained', color: 'primary', disabled: !action || !(plugin === null || plugin === void 0 ? void 0 : plugin.validate(action)), onClick: () => action && (onChange === null || onChange === void 0 ? void 0 : onChange(action)) }, "Save"))));
};
exports.WorkflowConfigInvokeActionDialog = WorkflowConfigInvokeActionDialog;
exports.default = exports.WorkflowConfigInvokeActionDialog;
//# sourceMappingURL=WorkflowConfigInvokeActionDialog.js.map